import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";

export const TextImageVideo = ({
  className,
  content,
  image,
  videoLink,
  containerWidth = false
}) => {
  return (
      <section className={`${styles.root} ${className}`}>
        <Container className={containerWidth ? "w-100" : ""}>
          <Row className="align-items-center">
            <Col md={7} className="px-5 mb-5 mb-md-0">
              {content && (
                <div dangerouslySetInnerHTML={{  __html: content }} />
              )}
            </Col>

            {videoLink ? (
              <Col className="position-relative">
                <div className="ratio ratio-16x9">
                  <iframe
                    src={videoLink}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </Col>
            ) : (
              <Col md={5}>
                <SourceFlowImage
                  src={
                    image?.url
                      ? image?.url
                      : "/site-assets/placeholders/img-placeholder.jpg"
                  }
                  size="800x800"
                  alt={image?.alt}
                  className="card-img rounded-4"
                />
              </Col>
            )}
          </Row>
        </Container>
      </section>
  );
}

export default TextImageVideo;
